import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getLang } from './services/lang';

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)

const resources = {
  en: {
    translation: {
      offline_text: 'Our websites are currently undergoing maintenance. Please login later in order to access our services. We apologize for the inconvenience.',
      'Laboratory Testing': 'Laboratory Testing',
      'Request lab testing now': 'Request lab testing now',
      'Medication Refill': 'Medication Refill',
      'Refill my medication now': 'Refill my medication now',
      'Book Appointment': 'Book Appointment',
      'Book appointment now': 'Book appointment now',
      'Book regular appointment': 'Book regular appointment',
      icbcclinic: 'icbcclinic',
      lab_sentence_1: 'Request lab tests using our website.',
      lab_sentence_2: 'After a review by our physician, the lab test form is emailed to you and LifeLabs quickly during our business hours.',
      'Refill up to 5 medications per day using our AskMedication.com website.': 'Refill up to 5 medications per day using our AskMedication.com website.',
      'Refill up to 5 medications per day using our Instore.AskMedication.com website.': 'Refill up to 5 medications per day using our Instore.AskMedication.com website.',
      'The most convenient way to refill your routine prescriptions!': 'The most convenient way to refill your routine prescriptions!',
      'Book an appointment to get a phone call from or see a doctor at the South Vancouver Medical Clinic.':
        'Book an appointment to get a phone call from or see a doctor at the South Vancouver Medical Clinic.',
      HOME: 'HOME',
      'CLINIC POLICIES': 'CLINIC POLICIES',
      FAQ: 'FAQ',
      'BOOK APPOINTMENT': 'BOOK APPOINTMENT',
      'SICK NOTE': 'SICK NOTE',
      'Sick Note Request': 'Sick Note Request',
      'REQUEST A FORM': 'REQUEST A FORM',
      'Request a Form': 'Request a Form',
      'Request a form to be filled out by a healthcare provider for school, work, disability, insurance or other purposes.':
        'Request a form to be filled out by a healthcare provider for school, work, disability, insurance or other purposes.',
      'In many cases, this can be done without coming to our medical clinic in person.': 'In many cases, this can be done without coming to our medical clinic in person.',
      'Request a form to be filled out by a healthcare provider for school, work, disability, insurance or other purposes. In many cases, this can be done without coming to our medical clinic in person.':
        'Request a form to be filled out by a healthcare provider for school, work, disability, insurance or other purposes. In many cases, this can be done without coming to our medical clinic in person.',
      'You obtain your sick note through email and likely would not need to come to our medical clinic in person.':
        'You obtain your sick note through email and likely would not need to come to our medical clinic in person.',
      'Ask the doctor to re-prescribe up to 5 medications per day using our Instore.AskMedication.com website.':
        'Ask the doctor to re-prescribe up to 5 medications per day using our Instore.AskMedication.com website.',
      'Medication and Testing': 'Medication and Testing',
      'Ask the doctor to re-prescribe up to 5 medications per day using our': 'Ask the doctor to re-prescribe up to 5 medications per day using our',
      'Instore.AskMedication.com': 'Instore.AskMedication.com',
      'website. Or request lab and radiology tests using our website. After a review by one of our physicians, the test form is emailed to you (':
        'website. Or request lab and radiology tests using our website. After a review by one of our physicians, the test form is emailed to you (',
      LifeLabs: 'LifeLabs',
      'for lab testing) during our business hours.': 'for lab testing) during our business hours.',
      'Book an in-person, phone at the Richmond In-Store Medical Clinic.': 'Book an in-person, phone at the Richmond In-Store Medical Clinic.',
      'Request a sick note (certificate for time off work or school due to illness) online.': 'Request a sick note (certificate for time off work or school due to illness) online.',
      'Available for MSP eligible patients ($65) or private patients ($130).': 'Available for MSP eligible patients ($65) or private patients ($130).',
      'Starting at $250 for the first page, with additional fees for complex forms.': 'Starting at $250 for the first page, with additional fees for complex forms.',
      'Patients who want to see their doctor at the medical clinic.': 'Patients who want to see their doctor at the medical clinic.',
      'For simple prescription refills': 'For simple prescription refills',
      'Not for stimulants (ADHD medications), opiates (pain pills) or benzodiazepines (sleeping pills)':
        'Not for stimulants (ADHD medications), opiates (pain pills) or benzodiazepines (sleeping pills)',
      'Only if 19-year-old or older': 'Only if 19-year-old or older',
      'Patients who require an immigration medical exam.': 'Patients who require an immigration medical exam.',
      'Patients who want their family doctor to call them back.': 'Patients who want their family doctor to call them back.',
      LOGIN: 'LOGIN',
      REGISTER: 'REGISTER',
      'Welcome to the SouthVanMed Dashboard': 'Welcome to the SouthVanMed Dashboard',
      'Our Services,': 'Our Services, ',
      'free with a valid BC Services Card (CareCard)': 'free with a valid BC Services Card (CareCard)',
      DASHBOARD: 'DASHBOARD',
      'MY ACCOUNT': 'MY ACCOUNT',
      'MY MESSAGES': 'MY MESSAGES',
      LOGOUT: 'LOGOUT',
      'SouthVanMed Dashboard': 'SouthVanMed Dashboard',
      Email: 'Email',
      Password: 'Password',
      'Forgot password': 'Forgot password',
      'New to South Vancouver Medical Clinic?': 'New to South Vancouver Medical Clinic? ',
      'Sign Up': 'Sign Up',
      'Log in': 'Log in',
      Regular: 'Regular',
      Hours: 'Hours',
      Monday: 'Monday',
      Friday: 'Friday',
      Saturdays: 'Saturdays',
      Sundays: 'Sundays',
      and: 'and',
      December: 'December',
      'Statutory Holidays': 'Statutory Holidays',
      'Telemedicine only': 'Telemedicine only',
      Closed: 'Closed',
      'Please note that exceptionally hours may change without notice.': 'Please note that exceptionally hours may change without notice.',
      'Please always book an appointment online as walk-ins during business hours may not be able to see a doctor':
        'Please always book an appointment online as walk-ins during business hours may not be able to see a doctor',
      Address: 'Address',
      'We are located on the 2nd floor of the Superstore on Marine Drive at Main Street.': 'We are located on the 2nd floor of the Superstore on Marine Drive at Main Street.',
      Fax: 'Fax',
      'in-person and telemedicine': 'in-person and telemedicine',
      'Inside Richmond Superstore, next to the pharmacy.': 'Inside Richmond Superstore, next to the pharmacy.',

      // Sick Note Landing specific translations
      "Need a doctor's note for work or school? Get a legally valid sick note online for $50. Fast, secure, and doctor-issued within 1 business day. PIPA compliant.":
        "Need a doctor's note for work or school? Get a legally valid sick note online for $50. Fast, secure, and doctor-issued within 1 business day. PIPA compliant.",
      "At the Richmond In-Store Medical Clinic, we offer a convenient online service for obtaining doctor's notes for work or school absences. Typically provided within 1 business day.":
        "At the Richmond In-Store Medical Clinic, we offer a convenient online service for obtaining doctor's notes for work or school absences. Typically provided within 1 business day.",

      // Medical Form Landing specific translations
      'Need a Form Filled Out? We Can Help.': 'Need a Form Filled Out? We Can Help.',
      'At the Richmond In-Store Medical Clinic, we offer a convenient service to help with your paperwork needs. No appointment necessary.':
        'At the Richmond In-Store Medical Clinic, we offer a convenient service to help with your paperwork needs. No appointment necessary.',

      // Sick Note Components specific translations
      'Online Sick Note Service': 'Online Sick Note Service',
      'Request a Sick Note Online – Fast, Secure, and Doctor-Issued': 'Request a Sick Note Online – Fast, Secure, and Doctor-Issued',
      'Need a sick note for work or school absence? Richmond In-Store Medical Clinic offers a fast and secure online sick note service. Submit your request in minutes and receive a doctor-issued note—often within 1 business day.':
        'Need a sick note for work or school absence? Richmond In-Store Medical Clinic offers a fast and secure online sick note service. Submit your request in minutes and receive a doctor-issued note—often within 1 business day.',
      "This service is trusted by patients across British Columbia. Your information is protected under BC's PIPA (Personal Information Protection Act).":
        "This service is trusted by patients across British Columbia. Your information is protected under BC's PIPA (Personal Information Protection Act).",
      'Please note:': 'Please note:',
      'A minimum fee of $65 applies. In some cases, the patient may need to be contacted by phone or seen in person or virtually before the note can be completed.':
        'A minimum fee of $65 applies. In some cases, the patient may need to be contacted by phone or seen in person or virtually before the note can be completed.',
      '✅': '✅',
      'Request your sick note now – fast, secure, and fully compliant.': 'Request your sick note now – fast, secure, and fully compliant.',
      'Doctor-reviewed and accepted by most employers and schools.': 'Doctor-reviewed and accepted by most employers and schools.',
      'Steps to obtain a sick note (doctor certificate) using instoremed.com': 'Steps to obtain a sick note (doctor certificate) using instoremed.com',
      'Submit Request': 'Submit Request',
      'Complete our secure online form with your details and reason for absence.': 'Complete our secure online form with your details and reason for absence.',
      'Doctor Review': 'Doctor Review',
      'Our licensed physicians review your request and may contact you if needed.': 'Our licensed physicians review your request and may contact you if needed.',
      'Pay securely online once your request is approved.': 'Pay securely online once your request is approved.',
      'Receive Note': 'Receive Note',
      'Your official sick note is emailed to you, usually within 1 business day.': 'Your official sick note is emailed to you, usually within 1 business day.',
      'Present to Employer': 'Present to Employer',
      'Print or forward the doctor-issued note to your employer or school.': 'Print or forward the doctor-issued note to your employer or school.',
      'Keep Records': 'Keep Records',
      'Save a copy for your personal medical records.': 'Save a copy for your personal medical records.',
      'Sick Note Fee': 'Sick Note Fee',
      Service: 'Service',
      'Valid B.C. Services Card (Care Card)': 'Valid B.C. Services Card (Care Card)',
      'No valid B.C. Services Card (Care Card)': 'No valid B.C. Services Card (Care Card)',
      'Additional fees may apply for complex cases requiring extended consultation or additional documentation.':
        'Additional fees may apply for complex cases requiring extended consultation or additional documentation.',
      'Sample Sick Note': 'Sample Sick Note',
      'How the Sick Note looks like': 'How the Sick Note looks like',
      'This is a sample format.': 'This is a sample format.',
      'Your actual sick note will include your specific information and medical details as provided by our licensed physicians.':
        'Your actual sick note will include your specific information and medical details as provided by our licensed physicians.',
      'Validate Sick Note': 'Validate Sick Note',
      'Verify the authenticity of a sick note issued by Richmond In-Store Medical Clinic': 'Verify the authenticity of a sick note issued by Richmond In-Store Medical Clinic',
      'Sick Note Verification': 'Sick Note Verification',
      'Employers and educational institutions can verify that sick notes were legitimately issued by our clinic.':
        'Employers and educational institutions can verify that sick notes were legitimately issued by our clinic.',
      "What You'll Need:": "What You'll Need:",
      'Sick Note ID': 'Sick Note ID',
      "Patient's First and Last Name": "Patient's First and Last Name",
      'Start and End Dates': 'Start and End Dates',

      // Medical Form Components specific translations
      'Professional Form Completion Service': 'Professional Form Completion Service',
      'Our healthcare providers can complete a wide variety of forms for work, school, insurance, and disability purposes. We review your medical history and provide accurate, professional documentation to meet your needs.':
        'Our healthcare providers can complete a wide variety of forms for work, school, insurance, and disability purposes. We review your medical history and provide accurate, professional documentation to meet your needs.',
      '✓ Quick Processing': '✓ Quick Processing',
      'Most forms completed within 1-2 business days': 'Most forms completed within 1-2 business days',
      '✓ Professional Review': '✓ Professional Review',
      'Thorough medical history assessment by healthcare providers': 'Thorough medical history assessment by healthcare providers',
      '✓ Secure Process': '✓ Secure Process',
      'PIPA compliant and confidential handling of your information': 'PIPA compliant and confidential handling of your information',
      '✓ No Appointment Required': '✓ No Appointment Required',
      'Complete the process entirely online': 'Complete the process entirely online',

      // FAQ Questions and Answers
      'How much does a sick note cost?': 'How much does a sick note cost?',
      "The typical fee is <strong>$65</strong>. If your request is more complex, we'll inform you of the full cost before proceeding.":
        "The typical fee is <strong>$65</strong>. If your request is more complex, we'll inform you of the full cost before proceeding.",
      'What types of sick notes do you provide?': 'What types of sick notes do you provide?',
      'We issue sick notes for:<ul><li>Work absence</li><li>School absence</li></ul>': 'We issue sick notes for:<ul><li>Work absence</li><li>School absence</li></ul>',
      'Work absence': 'Work absence',
      'School absence': 'School absence',
      'I need a more complex sick note. Can the doctor provide a sick note that is different from the sample displayed?':
        'I need a more complex sick note. Can the doctor provide a sick note that is different from the sample displayed?',
      'No, we only provide sick notes identical to the sample one shown above this notice. If you require a custom form to be filled out, please use the Medical Form service on our website. See Medical Forms under the Services+ tab at the very top of this page for details.':
        'No, we only provide sick notes identical to the sample one shown above this notice. If you require a custom form to be filled out, please use the Medical Form service on our website. See Medical Forms under the Services+ tab at the very top of this page for details.',
      'Will I need to speak with a doctor?': 'Will I need to speak with a doctor?',
      'In some cases, yes. You may be contacted for a <strong>phone or virtual consultation</strong> before your note is issued to ensure it meets medical and legal requirements.':
        'In some cases, yes. You may be contacted for a <strong>phone or virtual consultation</strong> before your note is issued to ensure it meets medical and legal requirements.',
      'How quickly will I receive the note?': 'How quickly will I receive the note?',
      'Most notes are issued within <strong>1 business day</strong>, provided all necessary information has been submitted.':
        'Most notes are issued within <strong>1 business day</strong>, provided all necessary information has been submitted.',
      'Is this service legally valid?': 'Is this service legally valid?',
      'Yes. All notes are issued by licensed Canadian physicians and are widely accepted by schools and employers across British Columbia.':
        'Yes. All notes are issued by licensed Canadian physicians and are widely accepted by schools and employers across British Columbia.',
      'How long of a sick note can you provide?': 'How long of a sick note can you provide?',
      'We only provide a maximum of 7 consecutive days for sick notes using our online service. If you need to be off for a longer time you must book an appointment and discuss with a provider.':
        'We only provide a maximum of 7 consecutive days for sick notes using our online service. If you need to be off for a longer time you must book an appointment and discuss with a provider.',
      'Are sick notes refundable?': 'Are sick notes refundable?',
      'No, sick notes are not refundable.': 'No, sick notes are not refundable.',
      'Is my information protected?': 'Is my information protected?',
      "Absolutely. We are fully compliant with <strong>BC's PIPA (Personal Information Protection Act)</strong> and use secure, encrypted platforms.":
        "Absolutely. We are fully compliant with <strong>BC's PIPA (Personal Information Protection Act)</strong> and use secure, encrypted platforms.",

      // Missing SickNote translations
      'Work absence': 'Work absence',
      'School absence': 'School absence',

      // Medical Form translations
      'How It Works': 'How It Works',
      'How It': 'How It',
      Works: 'Works',
      'Steps to get your medical forms completed at Richmond In-Store Medical Clinic': 'Steps to get your medical forms completed at Richmond In-Store Medical Clinic',
      'Upload Your Form': 'Upload Your Form',
      'Securely upload your form using our online request system.': 'Securely upload your form using our online request system.',
      'Complete Questionnaire': 'Complete Questionnaire',
      'Fill out a short questionnaire about your request.': 'Fill out a short questionnaire about your request.',
      Payment: 'Payment',
      'Pay the form completion fee.': 'Pay the form completion fee.',
      'Provider Review': 'Provider Review',
      'A healthcare provider will review your chart and complete the form.': 'A healthcare provider will review your chart and complete the form.',
      'Form Delivered': 'Form Delivered',
      "We'll email you the completed form.": "We'll email you the completed form.",
      'Use Your Form': 'Use Your Form',
      'Submit your completed form to the requesting organization.': 'Submit your completed form to the requesting organization.',
      'Examples of Forms We Complete': 'Examples of Forms We Complete',
      'Examples of Forms We': 'Examples of Forms We',
      Complete: 'Complete',
      'WorkSafeBC or ICBC Reports': 'WorkSafeBC or ICBC Reports',
      'Injury documentation and assessments for workplace or motor vehicle incidents.': 'Injury documentation and assessments for workplace or motor vehicle incidents.',
      'Disability or EI Medical Certificates': 'Disability or EI Medical Certificates',
      'Medical documentation for disability claims or Employment Insurance benefits.': 'Medical documentation for disability claims or Employment Insurance benefits.',
      'Return-to-work/school Clearance': 'Return-to-work/school Clearance',
      'Documentation confirming medical clearance to return to work or school.': 'Documentation confirming medical clearance to return to work or school.',
      'Insurance or Benefits Forms': 'Insurance or Benefits Forms',
      'Medical documentation needed for insurance claims or benefit applications.': 'Medical documentation needed for insurance claims or benefit applications.',
      'Fitness or Camp Forms': 'Fitness or Camp Forms',
      'Medical clearance forms for physical activities, sports, or camp attendance.': 'Medical clearance forms for physical activities, sports, or camp attendance.',
      'Form Type': 'Form Type',
      Price: 'Price',
      List: 'List',
      'Price List': 'Price List',
      'First page': 'First page',
      '$250 including GST': '$250 including GST',
      $250: '$250',
      'Additional Page (2-99 pages)': 'Additional Page (2-99 pages)',
      '$75 each including GST': '$75 each including GST',
      $75: '$75',
      each: 'each',
      'Disability Form': 'Disability Form',
      '$750 including GST': '$750 including GST',
      $750: '$750',
      'including GST': 'including GST',
      'Note: Form completion is not covered by MSP. Fees vary depending on complexity and will be confirmed before we begin.':
        'Note: Form completion is not covered by MSP. Fees vary depending on complexity and will be confirmed before we begin.',
      'Note:': 'Note:',
      '💡 Examples:': '💡 Examples:',
      'Examples:': 'Examples:',
      '1-page form: $250': '1-page form: $250',
      '1-page form:': '1-page form:',
      '3-page form: $400 ($250 + $75 + $75)': '3-page form: $400 ($250 + $75 + $75)',
      '3-page form:': '3-page form:',
      'Disability application: $750 (flat rate)': 'Disability application: $750 (flat rate)',
      'Disability application:': 'Disability application:',
      '(flat rate)': '(flat rate)',
      'Request Today': 'Request Today',
      Request: 'Request',
      Today: 'Today',
      'You will need to register at the Richmond In-Store Medical Clinic to proceed with your form request.':
        'You will need to register at the Richmond In-Store Medical Clinic to proceed with your form request.',
      'Click button below to proceed:': 'Click button below to proceed:',
      'We aim to complete most forms within 1-2 business days. For urgent requests, please email info@instoremed.com.':
        'We aim to complete most forms within 1-2 business days. For urgent requests, please email info@instoremed.com.',
      'We aim to complete most forms within 1-2 business days. For urgent requests, please email': 'We aim to complete most forms within 1-2 business days. For urgent requests, please email',
      'Frequently Asked': 'Frequently Asked',
      Questions: 'Questions',
      'Frequently Asked Questions': 'Frequently Asked Questions',

      // Medical Form FAQ
      'How much does it cost to have a form completed?': 'How much does it cost to have a form completed?',
      "There is a minimum fee of $250 for medical records review and physician time. The total cost depends on the type, length, and complexity of the form. You'll receive a quote before any work begins.":
        "There is a minimum fee of $250 for medical records review and physician time. The total cost depends on the type, length, and complexity of the form. You'll receive a quote before any work begins.",
      'What types of forms do you complete?': 'What types of forms do you complete?',
      'We complete a wide range of forms, including school absence and return-to-class forms, work accommodation or sick leave forms, disability or insurance forms (e.g., CPP-D, EI), travel cancellation forms, and fitness-to-work or return-to-work clearances.':
        'We complete a wide range of forms, including school absence and return-to-class forms, work accommodation or sick leave forms, disability or insurance forms (e.g., CPP-D, EI), travel cancellation forms, and fitness-to-work or return-to-work clearances.',
      "What's the difference between a form and a sick note?": "What's the difference between a form and a sick note?",
      'A sick note is a simple, standardized certificate for time off work or school. A form is more complex, requiring customized information and a thorough medical history review by your healthcare provider.':
        'A sick note is a simple, standardized certificate for time off work or school. A form is more complex, requiring customized information and a thorough medical history review by your healthcare provider.',
      'Will I need to speak with the doctor?': 'Will I need to speak with the doctor?',
      'In some cases, yes. You may be contacted by phone or asked to attend an in-person or virtual appointment before your form can be completed. This is to ensure accuracy and appropriateness of the documentation.':
        'In some cases, yes. You may be contacted by phone or asked to attend an in-person or virtual appointment before your form can be completed. This is to ensure accuracy and appropriateness of the documentation.',
      'How long does it take?': 'How long does it take?',
      'Most forms are completed within 1-2 business days after payment and submission of all required information. Some cases may require additional time if a consultation is needed.':
        'Most forms are completed within 1-2 business days after payment and submission of all required information. Some cases may require additional time if a consultation is needed.',
      'Do I need to be an existing patient?': 'Do I need to be an existing patient?',
      "No, you don't need to be an existing patient, but we may request additional medical records or information if necessary.":
        "No, you don't need to be an existing patient, but we may request additional medical records or information if necessary.",
      'Is my information secure?': 'Is my information secure?',
      'Yes, we are PIPA compliant and follow strict privacy protocols. Your personal health information is handled with the utmost confidentiality and security.':
        'Yes, we are PIPA compliant and follow strict privacy protocols. Your personal health information is handled with the utmost confidentiality and security.',
      'When do I need to pay?': 'When do I need to pay?',
      "Payment is required before we begin processing your form. You'll receive a quote and can pay securely online through our system.":
        "Payment is required before we begin processing your form. You'll receive a quote and can pay securely online through our system.",
      'Can you expedite urgent requests?': 'Can you expedite urgent requests?',
      "We aim to complete most forms within 1-2 business days. For urgent requests, please email info@instoremed.com and we'll do our best to accommodate your timeline.":
        "We aim to complete most forms within 1-2 business days. For urgent requests, please email info@instoremed.com and we'll do our best to accommodate your timeline.",
      'What if my form request is rejected?': 'What if my form request is rejected?',
      "Form completion is at the provider's discretion based on available medical information. If we cannot complete your form, we'll explain why and may suggest alternatives or additional steps needed.":
        "Form completion is at the provider's discretion based on available medical information. If we cannot complete your form, we'll explain why and may suggest alternatives or additional steps needed."
    }
  },
  cn: {
    translation: {
      offline_text: '我們的網站目前正在進行維護。請稍後登錄以訪問我們的服務。我們對不便表示抱歉。',
      'South Vancouver Medical Clinic': '南溫哥華醫療診所',
      'Laboratory Testing': '開化驗單',
      'Medication Refill': '處方續藥',
      'Request lab testing now': '開化驗單',
      'Request lab testing': '開化驗單',
      'Sick Note Request': '請求病假條',
      'Re-prescribe Medications': '續開處方藥',
      'Re-Prescribe Medications': '續開處方藥',
      'Refill my medication now': '續開處方藥',
      'Book Appointment': '預約醫生',
      'Book Immigration Medical Exam': '移民體檢預約',
      'Book appointment now': '預約醫生',
      'Book doctor appointment': '預約醫生',
      'Book family medicine appointment': '家庭醫生預約',
      'Book regular appointment': '普通預約',
      'Book ICBC appointment': 'ICBC預約',
      'Book driver physical': '司機體檢預約',
      "Book Driver's medical examination": '司機體檢預約',
      icbcclinic: 'icbcclinic',
      lab_sentence_1: '使用我們的網站開化驗單。',
      lab_sentence_2: '在我們的醫生審核後，化驗單會在我們的營業時間內通過電子郵件盡快發送給您和 LifeLabs。',
      'Ask the doctor to re-prescribe up to 5 medications per day using our AskMedication.com website.': '使用我們的 AskMedication.com 網站，每天可以向醫生請求續開最多5種處方藥。',
      'Refill up to 5 medications per day using our Instore.AskMedication.com website.': '使用我們的 Instore.AskMedication.com 網站，每天最多可以續開 5 種藥物。',
      'The most convenient way to renew your ongoing prescriptions!': '這是續開處方藥最便捷的方式！',
      'The most convenient way to refill your routine prescriptions!': '這是續開日常處方藥最便捷的方式！',
      'Book an appointment to get a phone call from or see a doctor at the South Vancouver Medical Clinic.': '預約面見醫生，或是與醫生電話會診。',
      'Book a regular or ICBC appointment to get a phone call from or see a doctor at the South Vancouver Medical Clinic.': '預約面見醫生，或是與醫生電話會診。',
      'Book an in-person, phone, driver physical or ICBC appointment at the South Vancouver Medical Clinic.': '預約面見醫生，或是與醫生電話會診。',
      'Request a sick note (certificate for time off work or school due to illness) online.': '在線申請病假單（因病休假或休學的證明）。',
      ' No need to come to the clinic, you will obtain your sick note through email.': '無需來診所，您將通過電子郵件獲得您的病假單。',
      'Request sick note': '請求病假條',
      HOME: '主頁',
      'CLINIC POLICIES': '診所政策',
      FAQ: '常見問題',
      'BOOK APPOINTMENT': '預約',
      'SICK NOTE': '病假條',
      'REQUEST A FORM': '申請表格',
      'FILL OUT MY FORM': '申請我的表格',
      'Request a Form': '申請表格',
      'Request a form to be filled out by a healthcare provider for school, work, disability, insurance or other purposes.': '申請由醫療服務提供者填寫的學校、工作、殘疾、保險或其他用途表格。',
      'In many cases, this can be done without coming to our medical clinic in person.': '在許多情況下，無需親自到我們的醫療診所即可完成。',
      'Request a form to be filled out by a healthcare provider for school, work, disability, insurance or other purposes. In many cases, this can be done without coming to our medical clinic in person.':
        '申請由醫療服務提供者填寫的學校、工作、殘疾、保險或其他用途表格。在許多情況下，無需親自到我們的醫療診所即可完成。',
      'You obtain your sick note through email and likely would not need to come to our medical clinic in person.': '您將通過電子郵件獲得病假條，可能無需親自到我們的醫療診所。',
      'Ask the doctor to re-prescribe up to 5 medications per day using our Instore.AskMedication.com website.': '使用我們的 Instore.AskMedication.com 網站，每天可以要求醫生重新開具最多 5 種藥物。',
      'Medication and Testing': '處方續藥及化驗',
      'Ask the doctor to re-prescribe up to 5 medications per day using our': '使用我們的',
      'Instore.AskMedication.com': 'Instore.AskMedication.com',
      'website. Or request lab and radiology tests using our website. After a review by one of our physicians, the test form is emailed to you (':
        '網站，每天可以要求醫生重新開具最多 5 種藥物。或使用我們的網站申請化驗和放射檢查。在我們的醫生審核後，測試表格會通過電子郵件發送給您（',
      LifeLabs: 'LifeLabs',
      'for lab testing) during our business hours.': '用於化驗）在我們的營業時間內。',
      'Book an in-person, phone at the Richmond In-Store Medical Clinic.': '在列治文店內醫療診所預約面診或電話諮詢。',
      'Available for MSP eligible patients ($65) or private patients ($130).': 'MSP 合資格患者（$65）或私人患者（$130）可使用。',
      'Starting at $250 for the first page, with additional fees for complex forms.': '首頁起價 $250，複雜表格需額外收費。',
      'Patients who want to see their doctor at the medical clinic.': '希望在醫療診所面診醫生的患者。',
      'For simple prescription refills': '用於簡單的處方續藥',
      'Not for stimulants (ADHD medications), opiates (pain pills) or benzodiazepines (sleeping pills)': '不適用於興奮劑（ADHD 藥物）、鴉片類藥物（止痛藥）或苯二氮卓類藥物（安眠藥）',
      'Only if 19-year-old or older': '僅限 19 歲或以上',
      'Patients who require an immigration medical exam.': '需要進行移民體檢的患者。',
      'Patients who want their family doctor to call them back.': '希望家庭醫生回電的患者。',
      'IMMIGRATION MEDICAL EXAM': '移民體檢',
      LOGIN: '登錄',
      REGISTER: '登記',
      'Welcome to the SouthVanMed Dashboard': '歡迎來到 SouthVanMed 主頁',
      'Welcome to the South Vancouver Medical Clinic': '歡迎來到South Vancouver醫療診所',
      'Home of ': '主頁：',
      ' and ': ' 和 ',
      'Our Services,': '我們的服務，',
      'free with a valid BC Services Card (CareCard)': '憑有效的 BC 服務卡 (CareCard) 免費',
      DASHBOARD: '主頁',
      'MY ACCOUNT': '我的帳戶',
      'MY MESSAGES': '我的消息',
      LOGOUT: '登出',
      'SouthVanMed Dashboard': 'SouthVanMed 主頁',
      Email: '電子郵件',
      Password: '密碼',
      'Forgot password': '忘記密碼',
      'New to South Vancouver Medical Clinic?': 'South Vancouver Medical Clinic 的新用戶？ ',
      'Sign Up': '登記',
      'Log in': '登錄',
      Regular: '常規',
      Hours: '時間',
      Monday: '星期一',
      Friday: '星期五',
      Saturdays: '星期六',
      Sundays: '星期日',
      and: '及',
      December: '十二月',
      'Statutory Holidays': '法定假期',
      'Telemedicine only': '僅遠程醫療',
      Closed: '休息',
      'Please note that exceptionally hours may change without notice.': '請注意，特殊時間可能會更改，恕不另行通知。',
      'Please always book an appointment online as walk-ins during business hours may not be able to see a doctor': '請務必在網上預約, 因為營業時間內無預約可能見不到醫生。',
      Address: '地址',
      'We are located on the 2nd floor of the Superstore on Marine Drive at Main Street.': '我們位於 Main Street 的 Marine Drive 的 Superstore 2 樓。',
      Fax: '傳真',
      'in-person and telemedicine': '面對面或者遠程醫療',
      'Inside Richmond Superstore, next to the pharmacy.': '在里士滿超市裡面，藥房旁邊。',

      // Sick Note specific translations
      'Get My Sick Note': '申請病假條',
      'Request Sick Note': '申請病假條',
      'Sick Note': '病假條',
      'sick note': '病假條',
      'likely would not': '很可能不需要',
      'MSP eligible': 'MSP 合資格',
      'private patients': '私人病人',
      "Need a doctor's note for work or school? Get a legally valid sick note online for $50. Fast, secure, and doctor-issued within 1 business day. PIPA compliant.":
        '需要工作或學校的醫生證明嗎？以$50在線獲得具有法律效力的病假條。快速、安全，醫生在1個工作日內簽發。符合PIPA標準。',
      "At the Richmond In-Store Medical Clinic, we offer a convenient online service for obtaining doctor's notes for work or school absences. Typically provided within 1 business day.":
        '在列治文店內醫療診所，我們提供便利的在線服務來獲取工作或學校缺勤的醫生證明。通常在1個工作日內提供。',

      // Sick Note Components specific translations
      'Online Sick Note Service': '在線病假條服務',
      'Request a Sick Note Online – Fast, Secure, and Doctor-Issued': '在線申請病假條 - 快速、安全、醫生簽發',
      'Need a sick note for work or school absence? Richmond In-Store Medical Clinic offers a fast and secure online sick note service. Submit your request in minutes and receive a doctor-issued note—often within 1 business day.':
        '需要工作或學校缺勤的病假條嗎？列治文店內醫療診所提供快速安全的在線病假條服務。幾分鐘內提交申請，通常在1個工作日內收到醫生簽發的證明。',
      "This service is trusted by patients across British Columbia. Your information is protected under BC's PIPA (Personal Information Protection Act).":
        '這項服務受到卑詩省各地患者的信任。您的信息受到卑詩省PIPA（個人信息保護法）的保護。',
      'Please note:': '請注意：',
      'A minimum fee of $65 applies. In some cases, the patient may need to be contacted by phone or seen in person or virtually before the note can be completed.':
        '最低費用為$65。在某些情況下，在完成證明之前，可能需要通過電話聯繫患者或進行面對面或虛擬會診。',
      '✅': '✅',
      'Request your sick note now – fast, secure, and fully compliant.': '立即申請您的病假條 - 快速、安全、完全合規。',
      'Doctor-reviewed and accepted by most employers and schools.': '經醫生審查，被大多數雇主和學校接受。',
      'Steps to obtain a sick note (doctor certificate) using instoremed.com': '使用instoremed.com獲取病假條（醫生證明）的步驟',
      'Submit Request': '提交申請',
      'Complete our secure online form with your details and reason for absence.': '填寫我們的安全在線表格，包括您的詳細信息和缺勤原因。',
      'Doctor Review': '醫生審查',
      'Our licensed physicians review your request and may contact you if needed.': '我們的執業醫生會審查您的申請，如有需要會聯繫您。',
      'Pay securely online once your request is approved.': '一旦您的申請獲得批准，請安全地在線付款。',
      'Receive Note': '收到證明',
      'Your official sick note is emailed to you, usually within 1 business day.': '您的正式病假條通常在1個工作日內通過電子郵件發送給您。',
      'Present to Employer': '提交給雇主',
      'Print or forward the doctor-issued note to your employer or school.': '打印或轉發醫生簽發的證明給您的雇主或學校。',
      'Keep Records': '保存記錄',
      'Save a copy for your personal medical records.': '為您的個人醫療記錄保存一份副本。',
      'Sick Note Fee': '病假條費用',
      Service: '服務',
      'Valid B.C. Services Card (Care Card)': '有效的卑詩省服務卡（護理卡）',
      'No valid B.C. Services Card (Care Card)': '無有效的卑詩省服務卡（護理卡）',
      'Additional fees may apply for complex cases requiring extended consultation or additional documentation.': '複雜案例可能需要額外費用，需要延長諮詢或額外文件。',
      'Sample Sick Note': '病假條樣本',
      'How the Sick Note looks like': '範例-病假條',
      'This is a sample format.': '這是一個範例格式。',
      'Your actual sick note will include your specific information and medical details as provided by our licensed physicians.': '您的實際病假條將包括我們執業醫生提供的您的具體信息和醫療詳情。',
      'Validate Sick Note': '驗證病假條',
      'Verify the authenticity of a sick note issued by Richmond In-Store Medical Clinic': '驗證列治文店內醫療診所簽發的病假條的真實性',
      'Sick Note Verification': '病假條驗證',
      'Employers and educational institutions can verify that sick notes were legitimately issued by our clinic.': '雇主和教育機構可以驗證病假條是否由我們診所合法簽發。',
      "What You'll Need:": '您需要的信息：',
      'Sick Note ID': '病假條ID',
      "Patient's First and Last Name": '患者姓名',
      'Start and End Dates': '開始和結束日期',

      // Medical Form specific translations
      'Request a Form': '申請表格',
      'school, work or disability': '學校、工作或殘疾',
      'Professional Form Completion Service': '專業表格填寫服務',
      'Need a Form Filled Out? We Can Help.': '需要填寫表格嗎？我們可以幫助您。',
      'At the Richmond In-Store Medical Clinic, we offer a convenient service to help with your paperwork needs. No appointment necessary.':
        '在列治文店內醫療診所，我們提供便利的服務來幫助您處理文件需求。無需預約。',
      'Our healthcare providers can complete a wide variety of forms for work, school, insurance, and disability purposes. We review your medical history and provide accurate, professional documentation to meet your needs.':
        '我們的醫療服務提供者可以完成各種工作、學校、保險和殘疾用途的表格。我們審查您的病史並提供準確、專業的文件以滿足您的需求。',
      '✓ Quick Processing': '✓ 快速處理',
      'Most forms completed within 1-2 business days': '大部分表格在1-2個工作日內完成',
      '✓ Professional Review': '✓ 專業審查',
      'Thorough medical history assessment by healthcare providers': '由醫療服務提供者進行全面的病史評估',
      '✓ Secure Process': '✓ 安全流程',
      'PIPA compliant and confidential handling of your information': '符合PIPA標準並保密處理您的信息',
      '✓ No Appointment Required': '✓ 無需預約',
      'Complete the process entirely online': '完全在線完成流程',

      // FAQ Questions and Answers Chinese
      'How much does a sick note cost?': '病假條費用是多少？',
      "The typical fee is <strong>$65</strong>. If your request is more complex, we'll inform you of the full cost before proceeding.":
        '典型費用為<strong>$65</strong>。如果您的申請更複雜，我們會在進行之前告知您全部費用。',
      'What types of sick notes do you provide?': '您提供什麼類型的病假條？',
      'We issue sick notes for:<ul><li>Work absence</li><li>School absence</li></ul>': '我們簽發以下病假條：<ul><li>工作缺勤</li><li>學校缺勤</li></ul>',
      'I need a more complex sick note. Can the doctor provide a sick note that is different from the sample displayed?': '我需要更複雜的病假條。醫生可以提供與顯示樣本不同的病假條嗎？',
      'No, we only provide sick notes identical to the sample one shown above this notice. If you require a custom form to be filled out, please use the Medical Form service on our website. See Medical Forms under the Services+ tab at the very top of this page for details.':
        '不，我們只提供與上述通知中顯示的樣本完全相同的病假條。如果您需要填寫定制表格，請使用我們網站上的醫療表格服務。詳情請參閱本頁頂部Services+標籤下的醫療表格。',
      'Will I need to speak with a doctor?': '我需要與醫生交談嗎？',
      'In some cases, yes. You may be contacted for a <strong>phone or virtual consultation</strong> before your note is issued to ensure it meets medical and legal requirements.':
        '在某些情況下，是的。在簽發您的證明之前，您可能會被聯繫進行<strong>電話或虛擬諮詢</strong>，以確保其符合醫療和法律要求。',
      'How quickly will I receive the note?': '我多快能收到證明？',
      'Most notes are issued within <strong>1 business day</strong>, provided all necessary information has been submitted.':
        '大多數證明在<strong>1個工作日</strong>內簽發，前提是已提交所有必要信息。',
      'Is this service legally valid?': '這項服務在法律上有效嗎？',
      'Yes. All notes are issued by licensed Canadian physicians and are widely accepted by schools and employers across British Columbia.':
        '是的。所有證明都由持牌加拿大醫生簽發，在卑詩省的學校和雇主中被廣泛接受。',
      'How long of a sick note can you provide?': '您可以提供多長時間的病假條？',
      'We only provide a maximum of 7 consecutive days for sick notes using our online service. If you need to be off for a longer time you must book an appointment and discuss with a provider.':
        '使用我們的在線服務，我們只提供最多連續7天的病假條。如果您需要請假更長時間，必須預約並與醫療服務提供者討論。',
      'Are sick notes refundable?': '病假條可以退款嗎？',
      'No, sick notes are not refundable.': '不，病假條不可退款。',
      'Is my information protected?': '我的信息受到保護嗎？',
      "Absolutely. We are fully compliant with <strong>BC's PIPA (Personal Information Protection Act)</strong> and use secure, encrypted platforms.":
        '絕對的。我們完全符合<strong>卑詩省PIPA（個人信息保護法）</strong>並使用安全的加密平台。',
      'Quick Processing': '快速處理',
      'Most forms completed within 1-2 business days': '大部分表格在1-2個工作日內完成',
      'Professional Review': '專業審查',
      'Thorough medical history assessment by healthcare providers': '由醫療服務提供者進行全面的病史評估',
      'Secure Process': '安全流程',
      'PIPA compliant and confidential handling of your information': '符合PIPA標準並保密處理您的信息',
      'No Appointment Required': '無需預約',
      'Complete the process entirely online': '完全在線完成流程',
      'How It Works': '操作流程',
      'Steps to get your medical forms completed at Richmond In-Store Medical Clinic': '在列治文店內醫療診所完成醫療表格的步驟',
      'Upload Your Form': '上傳您的表格',
      'Securely upload your form using our online request system.': '使用我們的在線申請系統安全上傳您的表格。',
      'Complete Questionnaire': '完成問卷',
      'Fill out a short questionnaire about your request.': '填寫關於您申請的簡短問卷。',
      Payment: '付款',
      'Pay the form completion fee.': '支付表格完成費用。',
      'Provider Review': '提供者審查',
      'A healthcare provider will review your chart and complete the form.': '醫療服務提供者將審查您的病歷並完成表格。',
      'Form Delivered': '表格交付',
      "We'll email you the completed form.": '我們將通過電子郵件向您發送完成的表格。',
      'Use Your Form': '使用您的表格',
      'Submit your completed form to the requesting organization.': '將您完成的表格提交給申請機構。',
      'Examples of Forms We Complete': '我們完成的表格範例',
      'WorkSafeBC or ICBC Reports': 'WorkSafeBC或ICBC報告',
      'Injury documentation and assessments for workplace or motor vehicle incidents.': '工作場所或機動車事故的傷害文件和評估。',
      'Disability or EI Medical Certificates': '殘疾或EI醫療證明',
      'Medical documentation for disability claims or Employment Insurance benefits.': '殘疾申請或就業保險福利的醫療文件。',
      'Return-to-work/school Clearance': '復工/復學許可',
      'Documentation confirming medical clearance to return to work or school.': '確認醫療許可復工或復學的文件。',
      'Insurance or Benefits Forms': '保險或福利表格',
      'Medical documentation needed for insurance claims or benefit applications.': '保險申請或福利申請所需的醫療文件。',
      'Fitness or Camp Forms': '健身或夏令營表格',
      'Medical clearance forms for physical activities, sports, or camp attendance.': '體育活動、運動或夏令營出席的醫療許可表格。',
      'Price List': '價格表',
      'Form Type': '表格類型',
      Price: '價格',
      'First page': '第一頁',
      'including GST': '包括GST',
      'Additional Page (2-99 pages)': '附加頁面（2-99頁）',
      each: '每頁',
      'Disability Form': '殘疾表格',
      Note: '注意:',
      'Form completion is not covered by MSP. Fees vary depending on complexity and will be confirmed before we begin.': '表格完成不在MSP覆蓋範圍內。費用根據複雜程度而異，我們將在開始前確認。',
      'Examples:': '範例：',
      '1-page form:': '1頁表格：',
      '3-page form:': '3頁表格：',
      'Disability application:': '殘疾申請：',
      '(flat rate)': '(固定費率）',
      'Request Today': '今天申請',
      'You will need to register at the Richmond In-Store Medical Clinic to proceed with your form request.': '您需要在列治文店內醫療診所註冊以繼續您的表格申請。',
      'Click button below to proceed:': '點擊下面的按鈕繼續：',
      'We aim to complete most forms within 1-2 business days. For urgent requests, please email': '我們的目標是在1-2個工作日內完成大部分表格。如有緊急申請，請發送電子郵件至',
      'Frequently Asked Questions': '常見問題',
      'How much does it cost to have a form completed?': '完成表格需要多少費用？',
      "There is a minimum fee of $250 for medical records review and physician time. The total cost depends on the type, length, and complexity of the form. You'll receive a quote before any work begins.":
        '醫療記錄審查和醫生時間的最低費用為$250。總費用取決於表格的類型、長度和複雜性。在開始任何工作之前，您將收到報價。',
      'What types of forms do you complete?': '您完成什麼類型的表格？',
      'We complete a wide range of forms, including school absence and return-to-class forms, work accommodation or sick leave forms, disability or insurance forms (e.g., CPP-D, EI), travel cancellation forms, and fitness-to-work or return-to-work clearances.':
        '我們完成各種表格，包括學校缺勤和復課表格、工作調整或病假表格、殘疾或保險表格（例如CPP-D、EI）、旅行取消表格以及適合工作或復工許可。',
      "What's the difference between a form and a sick note?": '表格和病假條有什麼區別？',
      'A sick note is a simple, standardized certificate for time off work or school. A form is more complex, requiring customized information and a thorough medical history review by your healthcare provider.':
        '病假條是一個簡單、標準化的工作或學校請假證明。表格更複雜，需要定制信息和由您的醫療服務提供者進行全面的病史審查。',
      'Will I need to speak with the doctor?': '我需要與醫生交談嗎？',
      'In some cases, yes. You may be contacted by phone or asked to attend an in-person or virtual appointment before your form can be completed. This is to ensure accuracy and appropriateness of the documentation.':
        '在某些情況下，是的。在您的表格完成之前，您可能會接到電話聯繫或被要求參加面對面或虛擬預約。這是為了確保文件的準確性和適當性。',
      'How long does it take?': '需要多長時間？',
      'Most forms are completed within 1-2 business days after payment and submission of all required information. Some cases may require additional time if a consultation is needed.':
        '大部分表格在付款和提交所有必需信息後的1-2個工作日內完成。如果需要諮詢，某些情況可能需要額外時間。',
      'Do I need to be an existing patient?': '我需要是現有病人嗎？',
      "No, you don't need to be an existing patient, but we may request additional medical records or information if necessary.":
        '不，您不需要是現有病人，但如有必要，我們可能會要求額外的醫療記錄或信息。',
      'Is my information secure?': '我的信息安全嗎？',
      'Yes, we are PIPA compliant and follow strict privacy protocols. Your personal health information is handled with the utmost confidentiality and security.':
        '是的，我們符合PIPA標準並遵循嚴格的隱私協議。您的個人健康信息以最高的保密性和安全性處理。',
      'When do I need to pay?': '我什麼時候需要付款？',
      "Payment is required before we begin processing your form. You'll receive a quote and can pay securely online through our system.":
        '在我們開始處理您的表格之前需要付款。您將收到報價並可以通過我們的系統安全在線付款。',
      'Can you expedite urgent requests?': '您能加急處理緊急申請嗎？',
      "We aim to complete most forms within 1-2 business days. For urgent requests, please email info@instoremed.com and we'll do our best to accommodate your timeline.":
        '我們的目標是在1-2個工作日內完成大部分表格。對於緊急申請，請發送電子郵件至info@instoremed.com，我們將盡力配合您的時間安排。',
      'What if my form request is rejected?': '如果我的表格申請被拒絕怎麼辦？',
      "Form completion is at the provider's discretion based on available medical information. If we cannot complete your form, we'll explain why and may suggest alternatives or additional steps needed.":
        '表格完成由提供者根據可用的醫療信息自行決定。如果我們無法完成您的表格，我們將解釋原因並可能建議替代方案或所需的額外步驟。'
    }
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: getLang(), // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
